module.exports = __webpack_public_path__ + "static/media/s4-bottom-extend-red.89693e5a.png";